// extracted by css-extract-rspack-plugin
export default {"CollapsedMoveParameterMenuInput":"Ot75F","MoveParameterMenuOptionIcon":"UupY5","MoveParameterMenuOptionText":"H1tEG","MoveParameterMenuOption":"u2qOD"};